//hooks/useUserProfile.jsx


import { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc, updateDoc } from 'firebase/firestore';
import { useAuth } from './useAuth';

const firestore = getFirestore();

const useUserProfile = () => {
  const { currentUser } = useAuth();
  const [profileData, setProfileData] = useState({
    fullName: '',
    email: '',
    phone: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch user profile data
  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }

    const fetchProfile = async () => {
      setLoading(true);
      try {
        const userDoc = await getDoc(doc(firestore, 'users', currentUser.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          const { fullName = '', email = '', phone = '' } = data;
          setProfileData({ fullName, email, phone });
        }
      } catch (err) {
        console.error('Error fetching profile data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [currentUser]);

  // Update user profile data
  const updateProfile = async (updatedData) => {
    if (!currentUser) return;
    try {
      const userDocRef = doc(firestore, 'users', currentUser.uid);
      await updateDoc(userDocRef, updatedData);
      setProfileData((prevData) => ({ ...prevData, ...updatedData }));
    } catch (err) {
      console.error('Error updating profile:', err);
      setError(err.message);
    }
  };

  return { profileData, setProfileData, loading, error, updateProfile };
};

export default useUserProfile;
